import styles from './DisagreementCard.module.css'

interface DisagreementCardProps {
  result: any
  correctedAudits: Set<string>
  onImageClick: (url: string) => void
  onMarkAICorrect: (auditObjectId: string) => void
  getHumanDefects: (humanResponse: any) => string
}

function DisagreementCard({
  result,
  correctedAudits,
  onImageClick,
  onMarkAICorrect,
  getHumanDefects,
}: DisagreementCardProps) {
  return (
    <div className={styles.disagreementCard}>
      {/* Images at Top */}
      <div className={styles.cardImagesSection}>
        {result.images &&
          result.images.map((img: any, imgIdx: number) => (
            <img
              key={imgIdx}
              src={img.url}
              alt={img.type}
              className={styles.cardImage}
              onClick={() => onImageClick(img.url)}
            />
          ))}
      </div>

      {/* Stacked Human/AI Decisions Below */}
      <div className={styles.cardDecisionsSection}>
        {/* Human Decision (Color-Coded) */}
        <div
          className={`${styles.decisionBlock} ${
            styles[
              `decision${
                result.humanDecision.charAt(0).toUpperCase() +
                result.humanDecision.slice(1)
              }`
            ]
          }`}
        >
          <div className={styles.decisionHeader}>
            <strong>Human:</strong>
            <span className={styles.decisionBadge}>
              {result.humanDecision.toUpperCase()}
            </span>
          </div>
          <div className={styles.decisionDetails}>
            <p>
              <strong>Defects:</strong> {getHumanDefects(result.humanResponse)}
            </p>
            {result.humanResponse?.coaching?.notes && (
              <p>
                <strong>Notes:</strong> {result.humanResponse.coaching.notes}
              </p>
            )}
          </div>
        </div>

        {/* AI Decision (Color-Coded) */}
        <div
          className={`${styles.decisionBlock} ${
            styles[
              `decision${
                result.aiDecision.charAt(0).toUpperCase() +
                result.aiDecision.slice(1)
              }`
            ]
          }`}
        >
          <div className={styles.decisionHeader}>
            <strong>AI:</strong>
            <span className={styles.decisionBadge}>
              {result.aiDecision.toUpperCase()}
            </span>
          </div>
          <div className={styles.decisionDetails}>
            <p>
              <strong>Reasoning:</strong> {result.aiReasoning}
            </p>
          </div>
        </div>

        {/* Correction Button */}
        <div className={styles.correctionSection}>
          <button
            className={`${styles.correctionButton} ${
              correctedAudits.has(result.auditObjectId)
                ? styles.correctionButtonActive
                : ''
            }`}
            onClick={() => onMarkAICorrect(result.auditObjectId)}
          >
            {correctedAudits.has(result.auditObjectId) ? (
              <>✓ AI Marked Correct</>
            ) : (
              <>Mark AI as Correct</>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default DisagreementCard
